import AddUserToCompany from '@rd-web-markets/shared/dist/user/AddUserToCompany';
export default AddUserToCompany;